module.exports = __webpack_public_path__ + "img/clock3.7d673708.svg";